
sap["ls"]["preload"]["UCF_Iframe"] = function() {/* global _assert, _trace, DEBUG */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_RequestUtil */
/// <reference path="../../core/util/RequestUtil.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_PlaceHolder */
/// <reference path="./base/PlaceHolder.js"/>

/**
 * 
 *
 * @class
 * @extends UCF_PlaceHolder
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_Iframe(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_Iframe["_"]["UCF_Iframe"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "Iframe.js(29): UCF_Iframe"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "Iframe.js(30): UCF_Iframe"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "Iframe.js(31): UCF_Iframe"); };

	UCF_PlaceHolder["apply"](this, [oDomRef, oLS]);

	this["attachBrowserEvent"]("load", this["oDomRef"]);
	if (this["bAutoHeight"]) {
		this["attachBrowserEvent"]("resize", this["oDomRef"]);
	}

	var self = this;
	UCF_DomUtil["attachEvent"](window, "message", this["postMessageHandler"] = function(oEvent) {
		if (oDomRef["contentWindow"] === oEvent["source"])
			self["fireSemanticEvent"]("Iframe", "Message", { "Id": self["sId"], "Data": oEvent["data"] }, false, false, false);
	});

	this["bLocked"] = false;
	this["bLoaded"] = false;
	this["bStopAdapting"] = false;
	this["bResizeInProgress"] = false;

	this["oLastSize"] = { "iHeight": 0, "iWidth": 0 };
	this["oSize"] = null;
	this["sCssHeight"] = null;
	this["sInitialHeight"] = this["sHeight"];

};window["UCF_Iframe"] = UCF_Iframe; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_Iframe"); UCF_Iframe["_"] = {UCF_Iframe: 0}; }; ;

UCF_Iframe["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_PlaceHolder"))(); UCF_Iframe.prototype["sClassName"] = "UCF_Iframe";

/**
 * Initialize, register the onload event of the iframe,
 * if the IFrame is already loaded, fire the Load event.
 *
 * The "loaded" attribute in the DOM is set by a script
 * directly defined in the renderer, as the onload
 * event of the iframe may occur before LightSpeed
 * has been initialized.
 */
UCF_Iframe["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["initialize"]++; }; 

	// If autoheight is enabled, and the height has been calculated before, set
	// the placeholder height, before calling super
	if (this["bKeepAlive"] && this["bAutoHeight"] && this["sCssHeight"]) {
		this["oGetRootRef"]()["style"]["height"] = this["sCssHeight"];
	}

	UCF_PlaceHolder.prototype["initialize"]["apply"](this, arguments);

	if (this["sPostParameters"]) {
		// do a post request but skip for frames that are marked with
		// loadedPOST flag (see 404550 2010).
		if (!this["oDomRef"]["loadedPOST"]) {
			var mParameters = UCF_JsUtil["mDecodeURIParameters"](this["sPostParameters"]);
			var sName = this["oDomRef"]["getAttribute"]("name");
			if (!sName) {
				sName = "iframe" + UCF_JsUtil["sGetUID"]();
				this["oDomRef"]["setAttribute"]("name", sName);
				this["oDomRef"]["contentWindow"]["name"] = sName;
			}
			UCF_RequestUtil["sendFormRequest"]("POST", this["sUrl"], mParameters, sName);
			this["oDomRef"]["loadedPOST"] = true;
		}

	} else if (this["oDomRef"]["loaded"]) {

		UCF_JsUtil["delayedCall"](0, this, "processLoad");

	} else if (!UCF_UserAgent["bIsIE"]()) {
		// support CSP and remove onload handler from HTML
		this["setUrl"](this["sUrl"]);

	}

	if (this["sLockBehavior"] === "ROUNDTRIP") {
		this["oLS"]["attachEvent"](this["oLS"]["E_EVENTS"]["Lock"], this, "lock");
		this["oLS"]["attachEvent"](this["oLS"]["E_EVENTS"]["Unlock"], this, "unlock");
		if (this["oLS"]["bIsLocked"]) this["lock"]();
	};

};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["initialize"] = 0; };

/**
 * Destructor
 */
UCF_Iframe["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["destroy"]++; }; 

	UCF_JsUtil["clearDelayedCallsOfObject"](this);

	// In rare cases the IFrame is destroyed twice (due to the delayed purgeControl of the PlaceHolder)
	if (this["oDomRef"]) {
		// change URL otherwise IFRAME unload on MSIE is not fired in reliable way - int.CSN 601001 2010
		if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) {
			this["setUrl"]("about:blank");
		}

		this["detachBrowserEvent"]("load", this["oDomRef"]);
		if (this["bAutoHeight"]) {
			this["detachBrowserEvent"]("resize", this["oDomRef"]);
			this["clearIntervalCall"]();
		}

		UCF_DomUtil["detachEvent"](window, "message", this["postMessageHandler"]);

		if (this["sLockBehavior"] === "ROUNDTRIP") {
			this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["Lock"], this, "lock");
			this["oLS"]["detachEvent"](this["oLS"]["E_EVENTS"]["Unlock"], this, "unlock");
			this["unlock"]();
		}
	}

	this["removeBlindLayer"]();

	this["oLastSize"] = null;
	this["oSize"] = null;
	this["oWebKitDiv"] = null;

	this["postMessageHandler"] = null;
	this["sCssHeight"] = null;
	this["sInitialHeight"] = null;
	this["sInterval"] = null;
	this["sHeight"] = null;

	UCF_PlaceHolder.prototype["destroy"]["apply"](this, arguments);

};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["destroy"] = 0; };

/**
 * Iframe onload handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_Iframe["prototype"]["onload"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["onload"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Iframe.js(164): onload"); };

	this["oDomRef"]["loaded"] = true;
	this["processLoad"]();
	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["onload"] = 0; };

/**
 * Iframe resize handler
 *
 * @param {UCF_BrowserEvent} oBrowserEvent
 */
UCF_Iframe["prototype"]["onresize"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["onresize"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Iframe.js(178): onresize"); };

	UCF_PlaceHolder.prototype["onresize"]["apply"](this, arguments);

	if (this["bLocked"]) {
		this["adaptBlindLayerSize"]();
	}
	if (this["bAutoHeight"]) {
		if (!this["bCanAccessFrame"]()) return;
		if (this["bLoaded"] && !this["bResizeInProgress"]) {
			this["checkSize"]();
		}
	}

	// In IE and Edge we get some wrong resize events in case of IFrame inside scroll-container and/or a vertical scrollbar exist:
	// - the Placeholder will change the oRootRef height or
	// - checkSize() will change the oDomRef height again
	// which will cause endless-resizing-loops unless we skip one check-intervall of the ResizeEventHelper
	if (UCF_UserAgent["bIsIE"]() || UCF_UserAgent["bIsMSEdge"]()) {
		this["oLS"]["oBrowserWindow"]["oResizeEventHelper"]["reset"](this["oRootRef"], this);
		this["oLS"]["oBrowserWindow"]["oResizeEventHelper"]["reset"](this["oDomRef"], this);
	}

	oBrowserEvent["cancelBubble"]();
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["onresize"] = 0; };

/**
 * Processing after Iframe is loaded
 * @param { UCF_BrowserEvent } oBrowserEvent
 */
UCF_Iframe["prototype"]["processLoad"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["processLoad"]++; }; 

	this["bLoaded"] = true;
	this["bStopAdapting"] = false;

	this["fireLoad"](this["sId"]);

	if (this["bAutoHeight"]) {
		if (!this["bCanAccessFrame"]()) return;
		if (this["oWebKitDiv"]) {
			this["oWebKitDiv"] = null;
		}
		if (!this["sInterval"]) {
			this["sInterval"] = UCF_JsUtil["intervalCall"](100, this, "checkSize");
		}
	}
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["processLoad"] = 0; };

/**
 * Check the size of the iframe content
 */
UCF_Iframe["prototype"]["checkSize"] = function() {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["checkSize"]++; }; 

	if (this["bResizeInProgress"]) return;
	if (!this["bCanAccessFrame"]()) return;

	this["oSize"] = this["oGetContentSize"]();
	if (this["oSize"]["iHeight"] !== this["oLastSize"]["iHeight"]) {
		this["adaptHeight"]();
		this["oLastSize"] = this["oSize"];
	}

};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["checkSize"] = 0; };

/**
 * Adapt the height of the iframe to the height of its content
 */
UCF_Iframe["prototype"]["adaptHeight"] = function() {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["adaptHeight"]++; }; 

	if (!this["bCanAccessFrame"]()) return;
	if (this["bStopAdapting"]) return;
	this["bResizeInProgress"] = true;

	var oNewSize;

	// Applying new height to the iframe
	this["oSize"] = this["oGetContentSize"]();
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Height 1: " + this["oSize"]["iHeight"], "Iframe.js(255): adaptHeight"); };
	this["sCssHeight"] = (this["oSize"]["iHeight"] + 1) + "px";
	this["setHeight"](this["sCssHeight"]);

	// If the width has changed (e.g. due to a scrollbar) apply height again
	oNewSize = this["oGetContentSize"]();
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Height 2: " + oNewSize["iHeight"], "Iframe.js(261): adaptHeight"); };
	if (oNewSize["iWidth"] !== this["oSize"]["iWidth"]) {
		this["oSize"] = oNewSize;
		this["sCssHeight"] = (this["oSize"]["iHeight"] + 1) + "px";
		this["setHeight"](this["sCssHeight"]);
	}

	// Continue after timeout to let the browser recalc iframe content size
	UCF_JsUtil["delayedCall"](0, this, "continueAdaptHeight", [0]);
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["adaptHeight"] = 0; };

/**
 * Adapt the height of the iframe to the height of its content
 * @param { int } iCount
 */
UCF_Iframe["prototype"]["continueAdaptHeight"] = function(iCount) {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["continueAdaptHeight"]++; }; 

	if (!this["bCanAccessFrame"]()) return;

	// If height is growing compared to before resize stop adapting
	var oNewSize = this["oGetContentSize"]();
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Height 3: " + oNewSize["iHeight"], "Iframe.js(282): continueAdaptHeight"); };
	if (oNewSize["iHeight"] !== this["oSize"]["iHeight"]) {
		// Try multiple times, in case the content size change was not caused by the iframe resize
		if (iCount < 3) {
			this["oSize"] = oNewSize;
			this["sCssHeight"] = (this["oSize"]["iHeight"] + 1) + "px";
			this["setHeight"](this["sCssHeight"]);
			UCF_JsUtil["delayedCall"](0, this, "continueAdaptHeight", [iCount + 1]);
			return;
		}
		// Iframe content is growing with iframe size - stop adapting
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "Stop adapting as content is growing or shrinking with iframe size", "Iframe.js(293): continueAdaptHeight"); };
		this["sCssHeight"] = this["sInitialHeight"];
		this["setHeight"](this["sCssHeight"]);
		this["clearIntervalCall"]();
		this["bStopAdapting"] = true;
	}

	if (this["sCssHeight"] !== this["sHeight"]) {
		this["sHeight"] = this["sCssHeight"];
		this["setClientProperty"]("Height", this["sHeight"], true);
		this["fireResize"](this["sId"], this["sHeight"]);
	}

	this["notifyLayoutChange"]();
	this["bResizeInProgress"] = false;
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["continueAdaptHeight"] = 0; };

/**
 * Set iframe height
 *
 * @param {string} sCssHeight
 */
UCF_Iframe["prototype"]["setHeight"] = function(sCssHeight) {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["setHeight"]++; }; 
	this["oGetRootRef"]()["style"]["height"] = sCssHeight;
	this["oGetObjectRef"]()["style"]["height"] = sCssHeight;
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["setHeight"] = 0; };

/**
 * Clear interval call
 *
 */
UCF_Iframe["prototype"]["clearIntervalCall"] = function() {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["clearIntervalCall"]++; }; 
	if (this["sInterval"]) {
		UCF_JsUtil["clearIntervalCall"](this["sInterval"]);
		this["sInterval"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["clearIntervalCall"] = 0; };

/**
 * Method to determine whether the frame content can be accessed
 * @return { boolean } bCanAccessFrame
 */
UCF_Iframe["prototype"]["bCanAccessFrame"] = function() {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["bCanAccessFrame"]++; }; 
	var bCanAccessFrame = false;
	var iHeight;
	try {
		iHeight = this["oDomRef"]["contentWindow"]["document"]["body"]["offsetHeight"];
		bCanAccessFrame = true;
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "IFrame content can be accessed, content height is " + iHeight, "Iframe.js(341): bCanAccessFrame"); };
	} catch (e) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, "IFrame content can not be accessed (different protocol/domain)", "Iframe.js(343): bCanAccessFrame"); };
	}
	return bCanAccessFrame;
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["bCanAccessFrame"] = 0; };

/**
 * Find out the actual height of the content inside the iframe
 * @return { Object } {iHeight: iContentHeight, iWidth: iContentWidth}
 */
UCF_Iframe["prototype"]["oGetContentSize"] = function() {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["oGetContentSize"]++; }; 
	var oFrameDocument = this["oDomRef"]["contentWindow"]["document"],
		oFrameBody = oFrameDocument["body"],
		iMarginTop = parseInt(UCF_DomUtil["sGetCurrentStyle"](oFrameBody, "marginTop"), 10),
		iMarginBottom = parseInt(UCF_DomUtil["sGetCurrentStyle"](oFrameBody, "marginBottom"), 10),
		iContentHeight, iContentWidth;

	if ((UCF_UserAgent["bIsIE"]() && window["UCF_System"]["sDevice"] !== "standards") && oFrameDocument["documentMode"] !== 8) {
		iContentHeight = oFrameBody["scrollHeight"];
		iContentWidth = oFrameBody["scrollWidth"];
	} else if (UCF_UserAgent["bIsWebKit"]()) {
		// WebKit does not provide any data about the content height, so as a workaround we
		// add a little div at the bottom of the page and ask for its top position
		if (!this["oWebKitDiv"]) {
			this["oWebKitDiv"] = oFrameDocument["createElement"]("div");
			this["oWebKitDiv"]["style"]["height"] = "1px";
		}
		oFrameDocument["body"]["appendChild"](this["oWebKitDiv"]);
		iContentWidth = oFrameBody["offsetWidth"];
		iContentHeight = this["oWebKitDiv"]["offsetTop"] + iMarginBottom;
		oFrameDocument["body"]["removeChild"](this["oWebKitDiv"]);
	} else {
		iContentHeight = oFrameBody["offsetHeight"] + iMarginTop + iMarginBottom;
		iContentWidth = oFrameBody["offsetWidth"];
	}

	return {
		"iHeight": iContentHeight,
		"iWidth": iContentWidth
	};
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["oGetContentSize"] = 0; };

/**
 * Sets the size of the blind layer
 */
UCF_Iframe["prototype"]["adaptBlindLayerSize"] = function() {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["adaptBlindLayerSize"]++; }; 
	if (!this["oBlindLayer"]) return;
	var oRect = this["oGetObjectRect"](this["oDomRef"]),
		oStyle = this["oBlindLayer"]["oDomRef"]["style"];
	oStyle["top"] = oRect["top"];
	oStyle["left"] = oRect["left"];
	oStyle["width"] = oRect["width"];
	oStyle["height"] = oRect["height"];
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["adaptBlindLayerSize"] = 0; };

/**
 * Adds the blind layer to capture events
 */
UCF_Iframe["prototype"]["addBlindLayer"] = function() {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["addBlindLayer"]++; }; 
	if (!this["oBlindLayer"]) {
		this["oBlindLayer"] = this["oLS"]["oGetBlindLayer"]();
		this["oBlindLayer"]["oDomRef"]["className"] = "lsnoprint";
	}
	this["adaptBlindLayerSize"]();
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["addBlindLayer"] = 0; };

/**
 * removes the blind layer
 */
UCF_Iframe["prototype"]["removeBlindLayer"] = function() {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["removeBlindLayer"]++; }; 
	if (this["oBlindLayer"]) {
		this["oLS"]["releaseBlindLayer"](this["oBlindLayer"]);
		this["oBlindLayer"] = null;
	}
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["removeBlindLayer"] = 0; };

/**
 * Locks the container for further event processing
 * @public
 */
UCF_Iframe["prototype"]["lock"] = function() {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["lock"]++; }; 

	if (this["sLockBehavior"] === "OFF") return;

	if (!this["bLocked"]) {
		if (!this["bAutoHeight"]) {
			this["attachBrowserEvent"]("resize", this["oDomRef"]);
		}
		this["addBlindLayer"]();
		this["bLocked"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["lock"] = 0; };

/**
 * Unlocks the iframe for further event processing
 * @public
 */
UCF_Iframe["prototype"]["unlock"] = function() {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["unlock"]++; }; 
	if (this["bLocked"]) {
		if (!this["bAutoHeight"]) {
			this["detachBrowserEvent"]("resize", this["oDomRef"]);
		}
		this["removeBlindLayer"]();
		this["bLocked"] = false;
	}
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["unlock"] = 0; };

/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occured
 */
UCF_Iframe["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["onlsskipforward"]++; }; 

	this["handleSkipForward"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occured
 */
UCF_Iframe["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["onlsskipback"]++; }; 

	this["handleSkipBack"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["onlsskipback"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element within the
 * control gets the focus.
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occured
 */
UCF_Iframe["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["onlsaccessibility"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "Iframe.js(477): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oSource = oBrowserEvent["oGetSource"]();
	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];

	if (oSource["getAttribute"]("tp") === "END") {
		oAccessibilityHelper["setControlType"]("IF_END");
	} else if (oSource["getAttribute"]("tp") === "START") {
		oAccessibilityHelper["setControlType"]("IF");
		oAccessibilityHelper["applyContainerEntryBehaviour"]();
		oAccessibilityHelper["setTooltip"](this["sTooltip"]);
	} else {
		oAccessibilityHelper["setControlType"]("IF");
	}
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["onlsaccessibility"] = 0; };

/**
 * sets the url of the iframe
 *
 * @param {string} sUrl the url to set
 */
UCF_Iframe["prototype"]["setUrl"] = function(sUrl) {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["setUrl"]++; }; 
	this["oDomRef"]["src"] = sUrl;
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["setUrl"] = 0; };

/**
 * send a message via postMessage api
 *
 * @param { string } sMessage the post message
 */
UCF_Iframe["prototype"]["postMessage"] = function(sMessage) {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["postMessage"]++; }; 
	this["oDomRef"]["contentWindow"]["postMessage"](sMessage, "*");
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["postMessage"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_Iframe["prototype"]["aAttributeNames"] = ["sHeight","sUrl","sTooltip","sVisibility","sLifeCycle","sPostParameters","bAutoHeight","sLockBehavior","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_Iframe["prototype"]["aEventNames"] = ["Load","Resize","Message"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_Iframe["prototype"]["aMethodNames"] = ["setKeepAlive","setUrl","postMessage","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_Iframe["prototype"]["sHeight"] = '150px';

/**
 * @private
 * @type {string}
 */
UCF_Iframe["prototype"]["sUrl"] = '';

/**
 * @private
 * @type {string}
 */
UCF_Iframe["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_Iframe["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {UCF_ClientInterfaces.E.LifeCycle}
 */
UCF_Iframe["prototype"]["sLifeCycle"] = "BROWSER";

/**
 * @private
 * @type {string}
 */
UCF_Iframe["prototype"]["sPostParameters"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_Iframe["prototype"]["bAutoHeight"] = false;

/**
 * @private
 * @type {UCF_ClientInterfaces.E.LockBehavior}
 */
UCF_Iframe["prototype"]["sLockBehavior"] = "ROUNDTRIP";

/**
 * @private
 * @type {string}
 */
UCF_Iframe["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_Iframe["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["setDefaultValues"]++; }; 
	this["sHeight"] = '150px';
	this["sUrl"] = '';
	this["sTooltip"] = '';
	this["sVisibility"] = "VISIBLE";
	this["sLifeCycle"] = "BROWSER";
	this["sPostParameters"] = '';
	this["bAutoHeight"] = false;
	this["sLockBehavior"] = "ROUNDTRIP";
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Height", '150px', true);
		this["setClientProperty"]("Url", '', true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("LifeCycle", "BROWSER", true);
		this["setClientProperty"]("PostParameters", '', true);
		this["setClientProperty"]("AutoHeight", false, true);
		this["setClientProperty"]("LockBehavior", "ROUNDTRIP", true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * @param {string} sId Identifier of the control
 * @fires Iframe::Load
 */
UCF_Iframe["prototype"]["fireLoad"] = function(sId) {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["fireLoad"]++; }; 
	/** @type {{Id: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 1, "arguments.length == 1", "Iframe.js(624): fireLoad"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Iframe.js(625): fireLoad"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Iframe.js(626): fireLoad"); };
	mParams = {
		"Id": sId
	};
	
	this["fireSemanticEvent"]("Iframe", "Load", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["fireLoad"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sHeight The new height after resizing
 * @fires Iframe::Resize
 */
UCF_Iframe["prototype"]["fireResize"] = function(sId, sHeight) {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["fireResize"]++; }; 
	/** @type {{Id: string, Height: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Iframe.js(644): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Iframe.js(645): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Iframe.js(646): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sHeight != null, "sHeight != null", "Iframe.js(647): fireResize"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sHeight) == "string", "typeof(sHeight) == \"string\"", "Iframe.js(648): fireResize"); };
	mParams = {
		"Id": sId,
		"Height": sHeight
	};
	
	
	this["fireSemanticEvent"]("Iframe", "Resize", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["fireResize"] = 0; };

/**
 * @protected
 * @param {string} sId Identifier of the control
 * @param {string} sData Message data
 * @fires Iframe::Message
 */
UCF_Iframe["prototype"]["fireMessage"] = function(sId, sData) {;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["fireMessage"]++; }; 
	/** @type {{Id: string, Data: string}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 2, "arguments.length == 2", "Iframe.js(668): fireMessage"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sId != null, "sId != null", "Iframe.js(669): fireMessage"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sId) == "string", "typeof(sId) == \"string\"", "Iframe.js(670): fireMessage"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(sData != null, "sData != null", "Iframe.js(671): fireMessage"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sData) == "string", "typeof(sData) == \"string\"", "Iframe.js(672): fireMessage"); };
	mParams = {
		"Id": sId,
		"Data": sData
	};
	
	
	this["fireSemanticEvent"]("Iframe", "Message", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_Iframe["_"]["fireMessage"] = 0; };

UCF_Iframe.prototype["aPublicMethods"] = ["lock","unlock"].concat(UCF_Iframe.prototype.aPublicMethods || []);
};